import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import "./LeavingCertificate.css"; // Create a CSS file for styling
import { baseUrl, formatDateToDDMMYYYY, currentDate } from "../../Utility/constants";
import axios from "axios";
import { LEAVING_CERTIFICATE, formatLCVersion } from "../../Utility/constants";
import { useLocation } from "react-router-dom";

const
  LeavingCertificate = () => {
    const { studentId, currentVersion, currentCertificateNumber, certificateId } =
      useParams();
    const location = useLocation();
    debugger
    const queryParams = new URLSearchParams(location.search);
    const certType = queryParams.get("certType") || "Original";
    const [schoolId, setSchoolId] = useState("");
    const [certificateData, setCertificateData] = useState([]);
    const [schoolData, setSchoolData] = useState([]);
    const hasCalled = useRef(false);

    useEffect(() => {
      const updateData = async () => {
        await updateCertificate();
      };
      updateData();
    }, []); // Ensure the dependency array is empty

    useEffect(() => {
      const fetchCertificateData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/PersonalDetails/ReturnStudentDetails?studentId=${studentId}`
          );
          if (response && response.data) {
            setCertificateData(response.data);
            if (response.data.schoolId) setSchoolId(response.data.schoolId);
          }
        } catch (error) {
          console.log(
            "Failed to fetch student details. Please try again.",
            error
          );
        }
      };
      fetchCertificateData();
    }, []);

    useEffect(() => {
      const updateLCVersion = async () => {
        if (hasCalled.current) return;

        hasCalled.current = true;

        const apiVersion = formatLCVersion(currentVersion).split("-")[1];

        const data = {
          studentId: studentId,
          certificateName: LEAVING_CERTIFICATE,
          version:
            currentVersion.toLowerCase() === "original"
              ? 1
              : parseInt(apiVersion) + 1,
        };

        try {
          await axios.post(`${baseUrl}/api/Numbering`, data);
        } catch (error) {
          console.error("Error sending data:", error);
        }
      };

      updateLCVersion();
    }, []);

    const updateCertificate = async () => {

      const data = {
        CertificateNo: currentCertificateNumber,
        studentId: parseInt(studentId),
        usedBy: localStorage.getItem("userID"),
        certificateName: LEAVING_CERTIFICATE,
        Id: parseInt(certificateId),
        certType: (queryParams.get("certType") || "").trim(),

      };
      try {
        await axios.put(`${baseUrl}/api/Numbering`, data);
      } catch (error) {
        console.error("Error sending data:", error);
      }
    };

    useEffect(() => {
      if (schoolId) {
        const fetchSchoolData = async () => {
          try {
            const response = await axios.get(
              `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
            );
            if (response && response.data) {
              setSchoolData(response.data);
            }
          } catch (error) {
            console.log(
              "Failed to fetch student details. Please try again.",
              error
            );
          }
        };
        fetchSchoolData();
      }
    }, [schoolId]);

    return (
      <div className="certificate-container">
        <div>
          <table className="header-table">
            <tbody>
              <tr>
                <td
                  style={{
                    width: "200px",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  <img src={schoolData.logo} className="responsive" width="150" />
                </td>
                <td style={{ borderRight: "none" }}>
                  <b style={{ fontSize: "18px" }}>
                    {schoolData.organizationName}{" "}
                  </b>
                  <br />
                  <b style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {schoolData.schoolOrCollegeName}
                  </b>
                  <br />
                  <b>(Affiliated to H.S.C. Board, Govt. Of Maharashtra)</b>
                  <br />
                  Address : {schoolData.address}
                  <br />
                  Phone No. <b>{schoolData.schoolOrCollegeContactNo}</b> | Website
                  : <b>{schoolData.schoolWebsiteName}</b>
                  <br></br>
                  Email : <b>{schoolData.email}</b>
                  <br />
                  U-DISE No : <b>{schoolData.udiseNo} </b> |{" "}
                  {(schoolData.ssC10thIndexNo || schoolData.hsC12thIndexNo) && (
                    <>
                      Index No :
                      <b>
                        {schoolData.ssC10thIndexNo}
                        {schoolData.ssC10thIndexNo &&
                          schoolData.hsC12thIndexNo &&
                          " | "}
                        {schoolData.hsC12thIndexNo}
                      </b>
                    </>
                  )}
                </td>
                <td style={{ width: "200px", borderLeft: "none" }}></td>
              </tr>
            </tbody>
          </table>
          <table className="header-table">
            <tbody>
              <tr>
                {/* First Column - School Recognition No */}
                <td style={{ width: "50%" }}>
                  School / College Recognition No.
                  <b>
                    {" "}
                    :{" "}
                    {schoolData.schoolRegistrationNumber &&
                      schoolData.schoolRegistrationNumber}
                    {schoolData.schoolRegistrationNumber &&
                      schoolData.collegeRegistrationNumber &&
                      " | "}
                    {schoolData.collegeRegistrationNumber &&
                      schoolData.collegeRegistrationNumber}
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          className="certificate-title mt-2 text-center"
          style={{ position: "relative" }}
        >
          <h5 className="title d-inline-block mx-2 mt-4">LEAVING CERTIFICATE</h5>
        </div>

        <div className="mt-1" style={{ position: "relative" }}>
          <span
            style={{
              color: "red",
              fontWeight: "bold",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            {certificateData.studentType === '17 No (Private/External)' ? 'Private' :
              // <p
              //   style={{
              //     color:
              //       currentVersion.toLowerCase() === "original" ? "green" : "red",
              //   }}
              // >
              //   {formatLCVersion(currentVersion.toUpperCase())}              
              // </p>
              <p
                style={{
                  color: certType === "Original" ? "green" : "red",
                    // fontWeight: "bold",
                    // fontSize: "18px",
                  textTransform: "uppercase",
                }}
              >
                {certType}
              </p>
            }
          </span>
          <span
            style={{ fontWeight: "bold", textAlign: "right", display: "block" }}
          >
            Certificate No: {currentCertificateNumber}
          </span>
        </div>

        <div className="certificate-body">
          <div className="certificate-section">
            <table className="certificate-table">
              <tbody>
                <tr>
                  <td>1</td>
                  <td>General Register No</td>
                  <td>
                    {certificateData.generalRegisterNo
                      ? certificateData.generalRegisterNo
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Student ID (SARAL)</td>
                  <td>
                    {certificateData.studentSaralId
                      ? certificateData.studentSaralId
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>APAAR ID</td>
                  <td>
                    {certificateData.apaarId ? certificateData.apaarId : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>National Code (PEN No)</td>
                  <td>
                    {certificateData.permanentEducationNumber
                      ? certificateData.permanentEducationNumber
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>UID (Aadhar No)</td>
                  <td>{certificateData.uidNo ? certificateData.uidNo : "N/A"}</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Name of the student (Full Name)</td>
                  <td>
                    {schoolData.lcNamingPrint
                      ? certificateData.lastName +
                      " " +
                      certificateData.firstName +
                      " " +
                      certificateData.middleName
                      : certificateData.firstName +
                      " " +
                      certificateData.middleName +
                      " " +
                      certificateData.lastName}
                  </td>
                </tr>
                
                <tr>
                  <td>7</td>
                  <td>Mother's Name</td>
                  <td>
                    {certificateData.motherFullName
                      ? certificateData.motherFullName
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Religion & Caste</td>
                  <td>
                    {certificateData.religion ? certificateData.religion : "N/A"}{" "}
                    {certificateData.caste ? certificateData.caste : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Nationality</td>
                  <td>{certificateData.hideNationality === true ? "-" : certificateData.nationality}</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Mother Tongue</td>
                  <td>
                    {certificateData.motherTongue
                      ? certificateData.motherTongue
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>
                    Place of Birth (Village/City, Tal., Zilla, State, Country):
                  </td>
                  <td>
                    {certificateData.birthPlace
                      ? certificateData.birthPlace
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Date of Birth (Words and Figures)</td>
                  <td>
                    {certificateData.dateOfBirth &&
                      formatDateToDDMMYYYY(
                        certificateData.dateOfBirth.split("T")[0]
                      )}{" "}
                    ({certificateData.dateOfBirthInWords})
                  </td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>Last School/College attended</td>
                  <td>
                    {certificateData.previousSchoolName
                      ? certificateData.previousSchoolName
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>Date of Admission & Class/Stream</td>
                  <td>
                    {certificateData.admissionDate &&
                      formatDateToDDMMYYYY(
                        certificateData.admissionDate.split("T")[0]
                      )}{" "}
                    -{" "}
                    {certificateData.standardName
                      ? certificateData.standardName
                      : "N/A"}
                    {"/"}
                    {certificateData.stream ? certificateData.stream : "N/A"}
                  </td>
                </tr>
                <tr>
                <td>15</td>
                <td>Progress</td>
                <td>{certificateData.lcProgress === "" ? "-" : certificateData.lcProgress}</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Conduct</td>
                <td>{certificateData.lcConduct === "" ? "-" : certificateData.lcConduct}</td>
              </tr>
                <tr>
                  <td>17</td>
                  <td>Date of Leaving the School/College</td>
                  <td>
                    {
                      certificateData.earlyRelease ?
                        formatDateToDDMMYYYY(certificateData.earlyReleaseDate.split("T")[0]) :
                        `31st May ${new Date().getFullYear()}`
                    }
                  </td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>Standard in which studying & since when</td>
                  <td>
                    {certificateData.standardName
                      ? certificateData.standardName
                      : "N/A"}{" "}
                    {certificateData.stream ? certificateData.stream : "N/A"}{" "}
                    since{" "}
                    {certificateData.admissionDate &&
                      certificateData.admissionDate.split("-")[0]}
                  </td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>Reason for leaving</td>
                  <td>
                   {certificateData.lcReason === "" ? "-" : certificateData.lcReason}
                  </td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>Remarks</td>
                  <td>
                    {certificateData.lcRemark === "" ? "-" : certificateData.lcRemark}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={3}
                    style={{ textAlign: "left", fontWeight: "normal" }}
                  >
                    <p>
                      Certified that the above information is in accordance with
                      the School/College General register.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="certificate-footer">
            <div className="signatures_LC">
              <div>Date: {currentDate()}</div>
              <div>Class Teacher</div>
              <div>Clerk</div>
              <div>Headmaster/Principal</div>
            </div>
            <div className="d-block text-start mt-1">
              Note:<br></br>
              1.Unauthorized change in school leaving certificate will lead to
              legal action against the concerned.<br></br>
              2.Government Decision - S.No.Sankirna - 2316 / (229/16) SD.4
            </div>
          </div>
        </div>
      </div>
    );
  };

export default LeavingCertificate;
